/* Project cards for the Projects index page */
export const PROJECTS = [
    {
        title: "BackScratch",
        subtitle: "I scratch yours, you scratch mine.",
        description:
            "A local services marketplace connecting neighbors who need a hand with neighbors who can help — built and shipped as a live web app.",
        link: "/projects/backscratch",
        available: true,
    },
    {
        title: "New Bedford Research & Robotics",
        subtitle: "Robotics Engineering, Rapid Prototyping & STEM Education",
        description:
            "3D design and rapid prototyping, AI development, and K-12 STEM education and mentorship — spanning the NBRR robotics program, the Torus project, and the Splinter toolhead system.",
        link: "/projects/robotics",
        available: true,
    },
    {
        title: "Algorithmic Trading",
        subtitle: "Systematic Strategy Research & Backtesting",
        description:
            "Signal research, backtesting, and execution tooling for systematic trading strategies.",
        link: "/projects/algotrade",
        available: true,
    },
];
